import { Outlet } from "react-router-dom";
import { MainFrame } from "@/common/MainFrame";

export function ModuleContainer() {
    return <MainFrame>
        <Outlet/>
    </MainFrame>;
}
